import * as React from 'react'

function SvgLinkedin(props) {
    return (
        <svg viewBox='0 0 456.23 456.23' {...props}>
            <defs>
                <style>{'.linkedin_svg__cls-2{fill:#272424}'}</style>
            </defs>
            <g id='linkedin_svg__Layer_2' data-name='Layer 2'>
                <g id='linkedin_svg__Capa_1' data-name='Capa 1'>
                    <rect
                        width={456.23}
                        height={456.23}
                        rx={25}
                        fill='#d7df22'
                    />
                    <path
                        className='linkedin_svg__cls-2'
                        d='M107.75 69.21a38.31 38.31 0 0138.05 38.24c-.05 22-18.28 38.52-38.3 38-20.31.41-38.16-16.55-38.15-38.19a38.33 38.33 0 0138.4-38.05zM129.93 386.47H85.21A10.51 10.51 0 0174.7 376V185.18a10.52 10.52 0 0110.51-10.51h44.72a10.51 10.51 0 0110.51 10.51V376a10.5 10.5 0 01-10.51 10.47zM387.38 241.68A72.42 72.42 0 00315 169.26h-11.51a64.41 64.41 0 00-56.36 33.27 4.45 4.45 0 00-.6-.08V179a4.36 4.36 0 00-4.36-4.36h-55.8A4.36 4.36 0 00182 179v203.11a4.36 4.36 0 004.36 4.36h57a4.37 4.37 0 004.37-4.37V264.8c0-20.28 16.17-37.12 36.45-37.35a36.89 36.89 0 0137.31 36.88v117.81a4.36 4.36 0 004.36 4.36H383a4.37 4.37 0 004.36-4.37V241.68z'
                    />
                </g>
            </g>
        </svg>
    )
}

export default SvgLinkedin
